import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { TextField, Select, MenuItem } from "@mui/material";
import { useRewardsForm } from "./hooks/useRewardsForm";
import { useRewardsConfig } from './hooks/useRewardsConfig';
import { ManageRewardsProps } from '../../customwidgets/coupons-rewards/types';
import { CouponDetail } from './CouponDetail';
import { DataSaverOn } from '@mui/icons-material';
import { rewardsLevelType } from '../../../util/DataObject';

export const ManageRewards = ({ changeAlert, onConfirm, onClose, open, title, data, tabActive, catalog }: ManageRewardsProps & DefaultComponentProps) => {
	const { formConfig, isValidFormConfig, onHandleChangeConfig, addCoupon, deleteCoupon } = useRewardsConfig(open, tabActive, data);
	const { form, onHandleChange, isValidForm } = useRewardsForm(open, tabActive, data, catalog);

	return (
		<Dialog onClose={onClose} open={open} style={{minWidth: tabActive === "promotions" || tabActive === "history_promo" ? '550px' : '700px', maxHeight: '500px'}}>
			<DialogTitle>
				<FlexGrid container fullWidth direction='column'>
					<Typography variant="h2">{title}</Typography>
					{ data && data["status"] === "disabled" && !data["active"] && <Typography variant="smallTitle" color='required'>Para reactivar el registro debes actualizar el período de vigencia</Typography>}
				</FlexGrid>
			</DialogTitle>
			<DialogContent style={{marginTop: 20}}>
				{tabActive === "promotions" || tabActive === "history_promo" ?
					<FlexGrid container direction="column" alignItems='flex-start' spacing={2}>
							<FlexGrid container fullWidth>
								<TextField value={form["title"]} onInput={onHandleChange.bind(this, "title", "")} label="Titulo" color="secondary" fullWidth/>
							</FlexGrid>
							<FlexGrid container fullWidth>
                                <Select MenuProps={{style: {zIndex: 35001}}} value={!data ? form["value"] || -1 : form["description"] || -1} onChange={onHandleChange.bind(this, !data ? "value" : "description" , "")} color='secondary' fullWidth>
                                    <MenuItem value={-1} disabled>Tipo de Operación</MenuItem>
                                    {catalog && catalog.map((t) => {
                                        return <MenuItem key={t.k} value={t.m[0]["acumulator_description"]}>{t.v}</MenuItem>
                                    })}
                                </Select>
							</FlexGrid>
						<FlexGrid container spacing={2} fullWidth>
							<TextField value={form["period"] && (form["period"]["sdate"]).substring(0, 10)} onInput={onHandleChange.bind(this, "period", "sdate")} InputLabelProps={{ shrink: true }} type="date" style={{ flex: 1, cursor: "pointer" }} color="secondary" label="Vigencia - Inicio" />
							<TextField value={form["period"] && (form["period"]["edate"]).substring(0, 10)} onInput={onHandleChange.bind(this, "period", "edate")} InputLabelProps={{ shrink: true }} type="date" style={{ flex: 1 }} color="secondary" label="Vigencia - Fin" />
						</FlexGrid>
						<FlexGrid container style={{width: "25%"}}>
							<TextField value={form["multiplier"]} onInput={onHandleChange.bind(this, "multiplier", "")} label="Multiplicador" color="secondary" />
						</FlexGrid>
					</FlexGrid>
					:
					<FlexGrid container direction="column" alignItems='flex-start' spacing={2}>
						<FlexGrid container spacing={2} fullWidth>
							<Select MenuProps={{style: {zIndex: 35001}}} value={formConfig["level_uuid"] || -1} onChange={onHandleChangeConfig.bind(this, "level_uuid" , "")} color='secondary' fullWidth>
								<MenuItem value={-1} disabled>Nivel</MenuItem>
								{rewardsLevelType && rewardsLevelType.map((t) => {
									return <MenuItem key={t.key} value={t.key}>{t.label}</MenuItem>
								})}
							</Select>
							<TextField value={formConfig["priority"]} onInput={onHandleChangeConfig.bind(this, "priority", "")} label="Prioridad" color="secondary" fullWidth/>
						</FlexGrid>
						<FlexGrid container spacing={2} fullWidth>
							<TextField value={formConfig["period"] && (formConfig["period"]["sdate"]).substring(0, 10)} onInput={onHandleChangeConfig.bind(this, "period", "sdate")} InputLabelProps={{ shrink: true }} type="date" style={{ flex: 1, cursor: "pointer" }} color="secondary" label="Vigencia - Inicio" />
							<TextField value={formConfig["period"] && (formConfig["period"]["edate"]).substring(0, 10)} onInput={onHandleChangeConfig.bind(this, "period", "edate")} InputLabelProps={{ shrink: true }} type="date" style={{ flex: 1 }} color="secondary" label="Vigencia - Fin" />
						</FlexGrid>
						<CouponDetail
							data={formConfig['coupons']}
							onHandleChangeConfig={onHandleChangeConfig}
							deleteCoupon={deleteCoupon}
						/>
						<Button onClick={addCoupon.bind(this)} style={{width: "40px", height: "40px", alignSelf: "end"}}><DataSaverOn /></Button>
					</FlexGrid>
				}
			</DialogContent>

			<DialogActions>
				<FlexGrid container fullHeight fullWidth justify='space-between' alignItems='flex-end' style={{ marginTop: '20px' }}>
					<FlexGrid item>
						<Button onClick={onClose} buttonType='secondary' size='normal'>
							Cancelar
						</Button>
					</FlexGrid>
					<FlexGrid item>
						<Button onClick={() => onConfirm(tabActive === "promotions" || tabActive === "history_promo" ? form : formConfig)} disabled={ tabActive === "promotions" || tabActive === "history_promo" ? isValidForm : isValidFormConfig} size='normal'>
							Aceptar
						</Button>
					</FlexGrid>
				</FlexGrid>
			</DialogActions>
		</Dialog>
	)
}